













import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...(mapGetters(['isUser']))
  }
})
export default class Header extends Vue {
  startFreeButtonClicked () {
    console.log('StartFreeClicked');
    this.$gtag.event('GoToRegister', {method: 'header'});
  }

  goToPanelClicked () {
    this.$gtag.event('GoToPanel', {method: 'header'});
  }
}
